import {
	AccountActiveIcon,
	AccountIcon,
	CustomerDashboardActive,
	CustomerDashboardIcon,
	HistoryIcon,
	HistoryIconActive,
	SupportIcon,
	SupportIconActive,
	WalletActiveIcon,
	WalletIcon,
} from "../../../assets/customermenu-icons";
import { MenuItem } from "./CustomerMenu.types";
export const menuItems: MenuItem[] = [
	{
		id: "home",
		label: "Home",
		icon: <CustomerDashboardIcon />,
		activeIcon: <CustomerDashboardActive />,
		path: "/dashboard",
		// No flag: Home is implied — every tenant has it.
	},

	{
		id: "history",
		label: "History",
		icon: <HistoryIcon />,
		activeIcon: <HistoryIconActive />,
		path: "/history",
	},
	{
		id: "wallet",
		label: "Wallet",
		icon: <WalletIcon />,
		activeIcon: <WalletActiveIcon />,
		path: "/wallet",
	},
	{
		id: "support",
		label: "Support",
		icon: <SupportIcon />,
		activeIcon: <SupportIconActive />,
		path: "/support",
		flag: "Support",
	},
	{
		id: "account",
		label: "Account",
		icon: <AccountIcon />,
		activeIcon: <AccountActiveIcon />,
		path: "/settings",
		// No flag: Home is implied — every tenant has it.
	},
];
